import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=9082371e&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9082371e')) {
      api.createRecord('9082371e', component.options)
    } else {
      api.reload('9082371e', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=9082371e&", function () {
      api.rerender('9082371e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27jJM3RswaXhi/JS/comp/starrating.vue"
export default component.exports